export enum ReportingGradeSubjectFeedbackModalTypeEnum {
    ATTITUDE_TOWARD_SCHOOL = "attitude_toward_school",
    WORK_ETHIC = "work_ethic",
    WORK_HABIT = "work_habits",
    SUMMARY = "summary",
    EXPERIENCE = "experience",
    TASKS = "how_did_progress_thought_tasks", // were goals achieved
    WORKING_ON = "has_been_working_on", // were changes made
    HIGHLIGHT = "what_was_the_highlight_of_year",
    LOWLIGHT = "what_was_the_lowlight_of_year",
    FAVOURITE_SUBJECT = "favourite_subject",
    LEARNING_STYLE = "what_was_the_most_comfortable_learning_style",
    COMMENT = "comment"
}
